var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCourseMenuModules(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/element-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "element-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.9535 5.68V2.65333C14.9535 1.71333 14.5367 1.33333 13.5014 1.33333H10.8707C9.83532 1.33333 9.41858 1.71333 9.41858 2.65333V5.67333C9.41858 6.62 9.83532 6.99333 10.8707 6.99333H13.5014C14.5367 6.99999 14.9535 6.62 14.9535 5.68Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.9535 13.18V10.4867C14.9535 9.42667 14.5367 9 13.5014 9H10.8707C9.83532 9 9.41858 9.42667 9.41858 10.4867V13.18C9.41858 14.24 9.83532 14.6667 10.8707 14.6667H13.5014C14.5367 14.6667 14.9535 14.24 14.9535 13.18Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.46518 5.68V2.65333C7.46518 1.71333 7.04844 1.33333 6.01309 1.33333H3.38239C2.34704 1.33333 1.9303 1.71333 1.9303 2.65333V5.67333C1.9303 6.62 2.34704 6.99333 3.38239 6.99333H6.01309C7.04844 6.99999 7.46518 6.62 7.46518 5.68Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7.46518 13.18V10.4867C7.46518 9.42667 7.04844 9 6.01309 9H3.38239C2.34704 9 1.9303 9.42667 1.9303 10.4867V13.18C1.9303 14.24 2.34704 14.6667 3.38239 14.6667H6.01309C7.04844 14.6667 7.46518 14.24 7.46518 13.18Z",
    fill: "#171717"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseMenuModules);
export default __webpack_public_path__ + "static/media/course_menu_modules.75e0835f6214acf71357bcd58238a231.svg";
export { ForwardRef as ReactComponent };